import { EstimatedTradeCostRequest } from 'widgets/estimatedTradeCost/store/data/EstimatedTradeCostRequest';
import { EstimatedTradeCostApiRequest } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiRequest';
import { EstimatedTradeCostApiResponse } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiResponse';
import { StreamMessage } from 'utils/messages/StreamMessage';
import uniq from 'lodash/uniq';

export type EstimatedTradeCostOrderDataState = {
    request: EstimatedTradeCostRequest;
    apiRequest: EstimatedTradeCostApiRequest;
    requestTimestamp: number;
    status: 'In Progress' | 'Completed' | 'Failed';
    response?: EstimatedTradeCostApiResponse;
    responseTimestamp?: number;
    error?: unknown;
};

export type EstimatedTradeCostDataState = {
    [uid: string]: EstimatedTradeCostOrderDataState;
};

export function extractErrorMessage(data?: EstimatedTradeCostOrderDataState) {
    const error = data?.error as { message?: string };
    return 'Query Failed' + (error?.message ? ` - ${error.message}` : '');
}

export function extractMessages(
    data?: EstimatedTradeCostOrderDataState
): StreamMessage[] {
    return uniq(
        [
            ...(data?.response?.errors ?? []),
            ...(data?.response?.warnings ?? []),
        ].map(({ message }) => ({
            message,
        }))
    );
}
